import { BuyerList } from 'ui/components/agent/patterns/BuyerList/BuyerList';

/**
 * 仲介企業用　買い手企業一覧
 */
export const AgentBuyerList: React.FC = () => {
    return <BuyerList />;
};
